import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import styles from "./NewsletterTerms.module.scss";
import { LEGAL_CONFIG } from "../../../config/legal";

const NewsletterTerms = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>
          <FormattedMessage
            id="legal.newsletter.title"
            defaultMessage="Newsletter terms for {platform}"
            values={{ platform: LEGAL_CONFIG.platformName.toUpperCase() }}
          />
        </h1>

        <section className={styles.section}>
          <h2>§1 Postanowienia ogolne</h2>
          <ol>
            <li>
              Niniejszy Regulamin okresla zasady korzystania z uslugi newslettera
              swiadczonej przez {LEGAL_CONFIG.companyName} z siedziba w{" "}
              {LEGAL_CONFIG.companyAddress}, NIP: {LEGAL_CONFIG.companyNip},
              REGON: {LEGAL_CONFIG.companyRegon}, dalej zwanej "Administratorem".
            </li>
            <li>
              Usluga newslettera polega na przesylaniu droga elektroniczna
              informacji handlowych, marketingowych, edukacyjnych oraz ofertowych
              dotyczacych dzialalnosci Platformy.
            </li>
            <li>Korzystanie z newslettera jest dobrowolne i bezplatne.</li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§2 Warunki korzystania z newslettera</h2>
          <ol>
            <li>
              Subskrypcja newslettera wymaga podania adresu e-mail oraz wyrazenia
              zgody na otrzymywanie informacji handlowych droga elektroniczna.
            </li>
            <li>
              Zapis do newslettera nastepuje poprzez formularz dostepny na stronie
              internetowej Platformy.
            </li>
            <li>
              Uzytkownik oswiadcza, ze podany adres e-mail jest prawidlowy i
              nalezy do niego.
            </li>
            <li>
              Administrator stosuje mechanizm double opt-in (potwierdzenie
              zapisu), w celu weryfikacji subskrypcji.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§3 Zakres tresci newslettera</h2>
          <ol>
            <li>
              Newsletter moze zawierac w szczegolnosci:
              <ul>
                <li>a) informacje o nowych produktach i tworcach,</li>
                <li>b) promocjach i rabatach,</li>
                <li>c) wydarzeniach, konkursach i akcjach specjalnych,</li>
                <li>
                  d) tresci edukacyjne i inspiracyjne zwiazane z tematyka
                  Platformy,
                </li>
                <li>e) informacje organizacyjne.</li>
              </ul>
            </li>
            <li>
              Administrator zastrzega sobie prawo do zmiany zakresu tresci
              newslettera.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§4 Rezygnacja z newslettera</h2>
          <ol>
            <li>
              Uzytkownik moze w kazdej chwili bez podania przyczyny zrezygnowac z
              otrzymywania newslettera.
            </li>
            <li>
              Rezygnacja nastepuje poprzez klikniecie linku "wypisz sie"
              znajdujacego sie w kazdej wiadomosci lub poprzez kontakt z
              Administratorem.
            </li>
            <li>
              Rezygnacja z newslettera jest rownoznaczna z usunieciem adresu
              e-mail z bazy mailingowej.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§5 Ochrona danych osobowych (RODO)</h2>
          <ol>
            <li>Administratorem danych osobowych jest {LEGAL_CONFIG.companyName}.</li>
            <li>
              Dane osobowe przetwarzane sa w celu realizacji uslugi newslettera
              na podstawie zgody Uzytkownika.
            </li>
            <li>
              Podanie danych jest dobrowolne, ale niezbedne do otrzymywania
              newslettera.
            </li>
            <li>
              Uzytkownik ma prawo do:
              <ul>
                <li>a) dostepu do danych,</li>
                <li>b) ich poprawiania,</li>
                <li>c) usuniecia,</li>
                <li>d) ograniczenia przetwarzania,</li>
                <li>e) cofniecia zgody w dowolnym momencie.</li>
              </ul>
            </li>
            <li>
              Szczegolowe informacje dotyczace przetwarzania danych znajduja sie
              w{" "}
              <Link to="/privacy-policy" className={styles.inlineLink}>
                Polityce Prywatnosci
              </Link>{" "}
              dostepnej na stronie Platformy.
            </li>
          </ol>
        </section>

        <section className={styles.section}>
          <h2>§6 Postanowienia koncowe</h2>
          <ol>
            <li>
              Administrator zastrzega sobie prawo do zmiany Regulaminu z waznych
              przyczyn prawnych, organizacyjnych lub technologicznych.
            </li>
            <li>O zmianach Uzytkownicy zostana poinformowani droga elektroniczna.</li>
            <li>
              W sprawach nieuregulowanych zastosowanie maja przepisy prawa
              polskiego.
            </li>
            <li>
              Regulamin obowiazuje od dnia{" "}
              {LEGAL_CONFIG.newsletterTermsEffectiveDate}.
            </li>
          </ol>
        </section>
      </div>
    </div>
  );
};

export default NewsletterTerms;
